import { useTranslation } from 'libs/i18n';
import { useFormContext } from 'modules/onboarding/common/forms/onboardingCitizenshipForm';

import { AddAndRemoveButtons } from '../../../AddAndRemoveButtons';

interface Props {
  index: number;
}

export const Buttons = ({ index }: Props) => {
  const { values, setValues } = useFormContext();

  const { t } = useTranslation();

  const onAdd = () => {
    values.citizenships.push(null);
    setValues(values, false);
  };

  const onRemove = (index: number) => {
    values.citizenships.splice(index, 1);
    setValues(values, false);
  };

  return (
    <AddAndRemoveButtons
      addLabel={t('onboarding.citizenship.addCitizenship')}
      counts={values.citizenships.length}
      index={index}
      removeLabel={t('onboarding.citizenship.removeCitizenship')}
      onAdd={onAdd}
      onRemove={onRemove}
    />
  );
};
